import {jwtServerInstance} from "../index";
import qs from	'qs'

export const getAllShopType = () =>{
    return jwtServerInstance.request({
        url:'/shoptype/all',
        method:'post'
    });
}
